import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import TopSection from "../../component/WarrantyExtensionComponent/TopSection";
import WarrantyForm from "../../component/WarrantyExtensionComponent/WarrantyForm";
import WarrantyDetails from "../../component/WarrantyExtensionComponent/WarrantyDetails";

@inject("CommonStore")
@observer
class WarrantyExtension extends Component {
  render() {
    const { isDesktop } = this.props.CommonStore;
    return (
      <div>
        {!isDesktop && (
          <WarrantyForm
            containerclassName="nw-mobile-only"
            formclassName="nw-mobile-only"
          />
        )}
        <TopSection />
        <WarrantyDetails />
      </div>
    );
  }
}
WarrantyExtension.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

export default WarrantyExtension;
